export default {
  'Extract audio': 'Extrair áudio',
  'Mute': 'Mudo',
  'Split video and audio': 'Separar vídeo e áudio',
}